import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/auth/updatePassword';

import { validateFieldValue } from './utils';

export default function* listenSetField() {
  yield takeEvery(actionTypes.setUpdatePasswordFieldValue.toString(), validateFieldValue);
}
